import { logException } from "../../../utils/sentry";

const sentry = ({ dispatch }) => next => action => {
  try {
    return next(action);
  } catch (err) {
    dispatch(
      logException(err, {
        action,
      }),
    );
  }
};

export default sentry;
